module.exports = __webpack_public_path__ + "static/media/disney-junior.923ede29.png";